class BusinessDate extends HTMLElement {
  
  _dateFormatter;

  constructor() {
    super();
    this._dateFormatter = new Intl.DateTimeFormat(navigator.language, { weekday: 'long', day: 'numeric', month: 'long' });
  }

  connectedCallback() {
    this._calculate();
  }

  get offsetValue() {
    return parseInt(this.getAttribute('days'));
  }

  _calculate() {
    const offset = this.offsetValue;
    let date = new Date();
    
    for (let i = 0; i <= offset; i++) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() == 6) {
        date.setDate(date.getDate() + 2);
      } else if (date.getDay() == 0) {
        date.setDate(date.getDate() + 1);
      }
    }

    console.dir(['dealloc/business-date#calculate', offset, date]);

    this._update(date);
  }

  _update(date) {
    this.textContent = this._dateFormatter.format(date);
  }

}

window.customElements.define('business-date', BusinessDate);